import React from "react";

const MAP = {
  approved: { bg: "#E9F0EB", text: "#3D624A", border: "#C4DFCD", label: "Approved" },
  pending: { bg: "#FDF2E9", text: "#A35C3E", border: "#F3D6BF", label: "Pending" },
  rejected: { bg: "#FAECEE", text: "#8C3B4A", border: "#EAC6CC", label: "Rejected" },
  cancelled: { bg: "#F0EFEA", text: "#6A736D", border: "#DFDDD4", label: "Cancelled" },
};

export const StatusBadge = ({ status }) => {
  const s = MAP[status] || MAP.pending;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border"
      style={{ backgroundColor: s.bg, color: s.text, borderColor: s.border }}
    >
      {s.label}
    </span>
  );
};

export const TypeBadge = ({ type }) => {
  const isSick = type === "sick";
  return (
    <span
      className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border"
      style={
        isSick
          ? { backgroundColor: "#FBEDE7", color: "#A35C3E", borderColor: "#F0D2C4" }
          : { backgroundColor: "#EAF0F5", color: "#3F5E7D", borderColor: "#CBDCEA" }
      }
    >
      {isSick ? "Sick" : "Holiday"}
    </span>
  );
};
